import React, { useState, useEffect, useRef } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as classnames from 'classnames';
import moment from 'moment';
import { s3LoadUrl } from '../../helper/s3LoadUrl';

import {
	getAlgoliaSearchUsers,
	addPatient,
	searchUserForId,
	addNewPatient
} from '../../app/actions/appActions';
import { showAlert } from '../../app/actions/uiActions';
import Title from '../../components/Title';
import Button from '../../components/Button';
import SearchForm from '../../components/SearchForm';
import Input from '../../components/Input';
import Select from '../../components/Select';
import User from '../../components/User';
import AlertMessage from '../../components/AlertMessage';
import { Close } from '../../static';
import Spinner from '../../components/Spinner';

import './styles.scss';

const Virus = ({
	virus, 
	virusId, 
	hcProviderId, 
	patients, 
	author, 
	currentPatient = {},
	patientForId,
	isLoadSpinner
}) => {
	const history = useHistory();
	const dispatch = useDispatch();
	const ui = useSelector((state) => state.ui);
	const [isActiveSearchResult, setActiveSearchResult] = useState(false);
	const [typeOfTestList, setTypeOfTestList] = useState([]);
	const [clearValue, setClearValue] = useState(false);
	const [toggleRedirect, setToggleRedirect] = useState(false);
	const togglePatientForId = useRef(false);

	const [state, setState] = useState({
		firstName: '',
		lastName: '',
		email: '',
		birthDate: '',
		phone: '',
		doctorName: '',
		isImmunity: false,
		notes: '',
		file: '',
		userId: '',
		position: '',
		authorFullName: '',
		virusId,
		hcProviderId,
		typeOfTest: '',
		expirationDate: ''
	});

	let bgUrl ='';

	if(virus && virus.backgroundImage) {
		bgUrl = s3LoadUrl(virus.backgroundImage);
	};

	const handleChangeInput = (target) => {

		if(target.type === 'file') {
			const file = target.files[0];

			if(file) {
				if(file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'application/pdf') {
					setState( (state)=> ({...state, file}));
				} else {
					dispatch(showAlert({type: 'error', message: 'The file does not match the type'}));
				};
			}
			
		} else  if(target.type === 'checkbox') {
			setState( (state)=> ({...state,[target.name]:target.checked}));
			
		} else if(target.id === 'type') {
			
			const curentType = typeOfTestList.filter(type => type.title === target.value);
			const typeOfTest = curentType[0].title;
			const expirationDate = curentType[0].value === "forever" ? true :  moment().add(curentType[0].value, 'M').format('MM/DD/YYYY');

			setState( (state)=> ({...state, expirationDate, typeOfTest}));

		} else  if( target.id === 'notes') {
			setState( (state)=> ({...state,[target.id]: {name: target.id, value: target.value} }));

		} else {
			setState( (state)=> ({...state,[target.id]:target.value}));
		};
	};

	const handleSearchUsers = (value) => {
		if(value) {
			dispatch(getAlgoliaSearchUsers({value, hcProviderId, type: 'patients'}));
			setActiveSearchResult(true);
		} else {
			setActiveSearchResult(false);
		}
	};

	const handleSearchDebounced = (value) => {
		if(value) {
			dispatch(getAlgoliaSearchUsers({value, hcProviderId, type: 'patients'}));
			setActiveSearchResult(true);
		} else {
			setActiveSearchResult(false);
		}
	}

	const handleSubmitPatient = (event) => {
		event.preventDefault();

		if(!state.typeOfTest && !state.expirationDate) {
			dispatch(showAlert({type: 'error', message: 'Fill in document type the fields'}));
			return;
		};

		if(!state.notes) {
			dispatch(showAlert({type: 'error', message: 'Fill in notes the fields'}));
			return;
		};

		if(!state.file.size) {
			dispatch(showAlert({type: 'error', message: 'Fill in file the fields'}));
			return;
		};

		if(state.userId) {
			dispatch(addPatient(state));
		} else {
			dispatch(addNewPatient(state, virus.name));
		};
	};

	const setNewUserToSetState = (patient) => {
		setState((state)=> ({
			...state,
			firstName: patient.firstName,
			lastName: patient.lastName,
			email: patient.email,
			birthDate: patient.birthDate,
			phone: patient.phone,
			userId: patient.userId,
			virusName: virus.name,
			position: author.position,
			authorFullName: `${author.firstName} ${author.lastName}`,
			parent : patient.parent ? patient.parent[0] : false,
		}));
	};

	const handleCheckPatient = (patient) => {
		setNewUserToSetState(patient);
		setActiveSearchResult(false);
		setClearValue(true)
		setTimeout(() => {
			setClearValue(false)
		},0)
	};

	const handleDeleteFile = () => {
		setState((state) => ({...state, file: ''}))
	};

	const handleSearchUserForId = (value) => {
		dispatch(searchUserForId(value));
	};

	useEffect(()=>{
		if(!patients.length) {
			setTimeout(()=>{
				setActiveSearchResult(false)
			},1000);
		};
	},[patients]);

	useEffect(() => {
		if(togglePatientForId.current) {
			
			if(patientForId.length) {

				setNewUserToSetState(patientForId[0]);
				setClearValue(true)
				setTimeout(() => {
					setClearValue(false)
				},0)
			} else {
				dispatch(showAlert({type: 'error', message: 'Users with this id were not found'}));
			}
		} else {
			togglePatientForId.current = true;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[patientForId])

	useEffect(() => {
		const isCurrentPatient = Object.keys(currentPatient);

		if(isCurrentPatient.length) {
			setState((state)=> ({
				...state,
				firstName: currentPatient.firstName,
				lastName: currentPatient.lastName,
				email: currentPatient.email,
				birthDate: currentPatient.birthDate,
				phone: currentPatient.phone,
				userId: currentPatient.userId,
				virusName: virus.name,
				position: author.position,
				authorFullName: `${author.firstName} ${author.lastName}`,
				expiration: {...virus.record_template[0]}
			}));
		};

		if(virus) {
			const nweFields = [];
			const fields = virus.record_template[1].fields;

			for(let key in fields) {
				const obj = {}
				obj.title = key;
				obj.value = fields[key]
				nweFields.push(obj)
			}
			setTypeOfTestList(nweFields);
		};

	}, [currentPatient,author,virus])

	useEffect(() => {
		if(isLoadSpinner) {
			setToggleRedirect(true)
		}

		if(toggleRedirect) {
			setTimeout(() => {
				history.push('/');
			}, 3000)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[isLoadSpinner])

	return (
		<div className="virus-wrapper">
		{
			virus && (
				<div className="virus">
					<header className="virus__header">
						<Title text={virus.name} isExtra isWhite/>
						<div className="virus__bg">
							<img src={bgUrl} alt="backgrund_virus"/>
						</div>
					</header>
					<div className="container">
						<div className="virus__content"						>
							<Title text={"Add New Patient to Virus"} isBig isBold/>
							<div className="virus__search-user-id">
								<SearchForm 
									onSubmit={handleSearchUserForId} 
									placeholder={"Search for id"}
									handleClearValue={clearValue}
								/>
								{/*<div className="virus__search-user-id__message">
									<AlertMessage showAlert={ui.showAlert}/>
								</div>*/}
							</div>
							<div className="virus__search">
								<div className="virus__search-form">
									<SearchForm 
										onSubmit={handleSearchUsers} 
										onChange={handleSearchDebounced} 
										type='instantly'
										handleClearValue={clearValue}
									/>
								</div>
								<div 
									className={classnames('virus__search-result',{
										'virus__search-result--active' : isActiveSearchResult
									})}
								>
									{ patients.length ? patients.map((patient, i) => {
										
										return 	(
											<div 
												className="virus__search-patient"
												onClick={() => handleCheckPatient(patient)} 
												key={i}
											>
												<User 
													user={{
														firstName: patient.firstName,
														lastName: patient.lastName,
														avatar: patient.avatar
													}} 
												/>
											</div>

										)}) : (
											<div className="virus__search-text">
												No such patients
											</div>
										)
									}
								</div>
							</div>
							<form onSubmit={handleSubmitPatient}>
								<div className="virus__row">
									<div className="virus__col virus__col--margin-right">
										<Input 
											value={state.firstName}
											id='firstName'
											type='text' 
											label='first Name' 
											onChange={handleChangeInput}
											required
										/>
									</div>
									<div className="virus__col">
										<Input 
											value={state.lastName}
											id='lastName'
											type='text' 
											label='last Name' 
											onChange={handleChangeInput}
											required
										/>

									</div>
								</div>
								<div className="virus__row">
									<div className="virus__col virus__col--margin-right">
										<Input 
											value={state.email}
											id='email'
											type='email' 
											label='email' 
											onChange={handleChangeInput}
											required
										/>
									</div>
									<div className="virus__row virus__col">
										<div className="virus__col virus__col--margin-right">
											<Input 
												value={state.birthDate}
												id='birthDate'
												type='date' 
												label='DOB'
												onChange={handleChangeInput}
											/>
										</div>
										<div className="virus__col">
											<Input 
												value={state.phone}
												id='phone'
												type='tel' 
												label='phone'
												onChange={handleChangeInput}
											/>
										</div>
									</div>
								</div>
								<Input 
									value={state.doctorName}
									id='doctorName'
									type='text' 
									label='Doctor name'
									onChange={handleChangeInput}
									required
								/>
								<Select 
									id='type'
									defaultText='Type of test'
									value={handleChangeInput}
									optionsList={typeOfTestList} 
								/>
								<Input 
									value={state.isImmunity}
									id='isImmunity'
									type='checkbox' 
									label={state.isImmunity ? 'Positive' : 'Negative'}
									onChange={handleChangeInput}
								/>
								<p>* If this test was a vaccine, choose "Positive" to represent you being vaccinated</p>
								<Input 
									value={state.textarea}
									id='notes'
									type='textarea' 
									placeholder={"Doctor notes..."}
									onChange={handleChangeInput}
								/>
						
								<Input 
									value={state.file}
									id='file'
									type='file' 
									label='Add image or PDF'
									onChange={handleChangeInput}
									isFileStyle
								/>
								<div>
									{
										state.file ? (
											<div className="virus__file">
												{state.file.name}
												<div 
													className="virus__file-icon" 
													onClick={handleDeleteFile}
												>
													<Close />
												</div>
											</div>
										) : null
									}
								</div>
								<AlertMessage showAlert={ui.showAlert}/>
								<div className="virus__btn">
									<Button text='Add Patient'/>
								</div>
								
							</form>
						</div>
					</div>
				</div>
			)
		}
		{isLoadSpinner && (
			<div className="virus__spinner-wrapper">
				<div className="virus__spinner">
					<Spinner />
				</div>
			</div>
		)}
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	const virusId = ownProps.match.params.id;
	const userId = ownProps.match.params.userId;
	const availableViruses = state.firestore.data.available_viruses;
	const virus = availableViruses ? availableViruses[virusId] : null;
	const currentPatients =  state.app.currentPatients;
	
	let currentPatient = {};
	const isCurrentPatients = Object.keys(currentPatients)

	if(userId && isCurrentPatients) {
		currentPatient = currentPatients[userId]
	}

	return {
		virus,
		virusId,
		patients: state.app.patients,
		patientForId: state.app.patientForId,
		hcProviderId: state.firebase.auth.uid,
		author: state.firebase.profile,
		isLoadSpinner: state.ui.isLoadSpinner,
		currentPatient
	};
};

export default connect(mapStateToProps)(Virus);
